import { InputField } from 'components/molecules'
import { Formik, Form } from 'formik'
import PropTypes from 'prop-types'
import { Button, FormGroup, Label, Input, FormText } from 'reactstrap'
import UpdateShipmentSchema from './update-shipment-schema'

const propTypes = {
  deal: PropTypes.object.isRequired,
  onSubmitForm: PropTypes.func.isRequired
}

/**
  * @param {Object} deal - current deal object
  * @param {Function} onSubmitForm - form submission callback
  */
const UpdateShipmentForm = ({ deal, onSubmitForm }) => {
  const initialValues = {
    tracking_number: deal?.shipment?.tracking_number || '',
    proof_of_shipping_image: null
  }

  return (
    <Formik
      initialValues={ initialValues }
      validationSchema={ UpdateShipmentSchema }
      onSubmit={ (values, formikBag) => onSubmitForm(values, formikBag) }
    >
      {(formikBag) => (
        <Form onSubmit={(e) => e.preventDefault()}>
          {/* Tracking number input */}
          <InputField
            type='text'
            name='tracking_number'
            label='Nomor Resi'
            formText="Masukkan nomor resi jika ada"
          />

          {/* File upload field */}
          <FormGroup>
            <Label for='proof_of_shipping_image'>Bukti Pengiriman</Label>
            <Input
              id='proof_of_shipping_image'
              name='proof_of_shipping_image'
              type='file'
              accept='image/jpeg,image/jpg,image/png,image/webp'
              onChange={(event) => {
                const file = event.currentTarget.files[0]
                formikBag.setFieldValue('proof_of_shipping_image', file)
              }}
            />
            {
              deal.shipment.proof_of_shipping_image_url
              &&
              <img
                style={{width: '400px', marginTop: "16px"}}
                alt="Bukti Pengiriman"
                src={deal.shipment.proof_of_shipping_image_url}
              />
            }
            {formikBag.errors?.proof_of_shipping_image && (
              <FormText color='danger'>
                {formikBag.errors.proof_of_shipping_image}
              </FormText>
            )}
          </FormGroup>

          {/* Submit button */}
          <Button
            color='primary'
            disabled={formikBag.isSubmitting}
            onClick={async () => {
              const errors = await formikBag.validateForm()
              if (Object.keys(errors).length > 0) {
                alert(`Please fix validation errors before submitting!\n${JSON.stringify(errors, null, 2)}`)
              } else {
                formikBag.submitForm()
              }
            }}
          >
            Update
          </Button>
        </Form>
      )}
    </Formik>
  )
}

UpdateShipmentForm.propTypes = propTypes

export default UpdateShipmentForm
